import { toast } from 'react-toastify';
import { toastResponse } from '../../../../helper components/Toast/Toast';

import { Modal } from 'react-bootstrap';
import Button from 'react-bootstrap/Button';
import { DataTable } from 'primereact/datatable';
import React, { useState, useEffect, useCallback } from 'react';
import { Column } from 'primereact/column';
import { FilterMatchMode } from 'primereact/api';
import allImages from '../../../../assets/images/allImages';
import { useNavigate } from 'react-router-dom';
import './uploadHistory.component.scss';
import { GetUploadedHistoryByEnterpriseIdV2 } from '../../../../Queries/QueriesUpdated';
import { useDispatch, useSelector } from 'react-redux';
import { useApolloClient, useQuery } from '@apollo/client';
import { globalError } from '../../../../utils/global-error-handler';
import { isLogout } from '../../../../Redux/authSlice';
import { setLoaderFalse, setLoaderTrue } from '../../../../Redux/loaderSlice';

export const UploadHistory = () => {
  /**
   * DECLARING STATES AND USEEFFECT
   */

  const navigate = useNavigate();
  const client = useApolloClient();
  const dispatch = useDispatch();
  const authReducer = useSelector((state) => state.authReducer);

  const [history, setHistory] = useState([]);
  const [showRowDetailsPopup, setShowRowDetailsPopup] = useState(false);
  const [selectedRow, setSelectedRow] = useState();

  const [globalFilterValue, setGlobalFilterValue] = useState('');
  const [filters, setFilter] = useState({
    global: {
      value: null,
      matchMode: FilterMatchMode.CONTAINS,
    },
  });

  const { refetch } = useQuery(
    GetUploadedHistoryByEnterpriseIdV2,
  );

  const statusBody = (rowData) => {
    return (
      <>
        {rowData.status === 'DONE' ? (
          <div className="action-btn">
            <Button
              className="p-2 py-1 btn-hover-color"
              style={{ background: '#03c4de' }}
              onClick={() => downloadCSV(rowData)}
            >
              Download
            </Button>
          </div>
        ) : (
          <div className="action-btn">
            <div
              className={` py-1 ${rowData.status === 'DONE' ? 'text-success' : 'text-danger'}`}
            >
              {rowData.status}
            </div>
          </div>
        )}

        <div
          className={`columnData py-1 ${rowData.status === 'DONE' ? 'text-success' : 'text-danger'}`}
        >
          {rowData.status}
        </div>
      </>
    );
  };

  const downloadCSV = async(fetchRowData) => {
    try {
      // const response = await fetch(fetchRowData?.file?.presignedURL);
      // // const response = fetch(fetchRowData?.file?.presignedURL);
      
      // if (fetchRowData?.file?.presignedURL) {
      //   const blob = await response.blob();

      //   // Create a link element and simulate a click to trigger the download
      //   const link = document.createElement('a');
      //   link.href = window.URL.createObjectURL(blob);
      //   link.download = 'downloadedFile.txt';
      //   document.body.appendChild(link);
      //   link.click();
      //   document.body.removeChild(link);

      const proxiedUrl = fetchRowData?.file?.presignedURL ?? 'https://bond-customer-documents-dev.s3.us-west-2.amazonaws.com/DEFAULT/EMPLOYEE_TEMPLATE.csv';
      const downloadElement = document.createElement('a');
      downloadElement.href = proxiedUrl;
      // todo add if required
      // downloadElement.setAttribute('download');
      downloadElement.click()

      // const response = await fetch(proxiedUrl);
      // const blob = await response.blob();

      // const url = window.URL.createObjectURL(new Blob([blob]));
      // const a = document.createElement('a');
      // a.href = url;
      // a.download = 'example.csv';
      // document.body.appendChild(a);
      // a.click();
      // document.body.removeChild(a);

      // window.open(fetchRowData?.file?.presignedURL);
      // } else {
      //   console.log('Error downloading file:');
      // }
    } catch (error) {
      console.log('Error downloading file:', error.message);
    }
  };

  const handleRowClick = (rowData) => {
    // debugger
    setShowRowDetailsPopup(true);
    setSelectedRow(rowData);
    // if (rowData.data?.uploadStatus === 'Successful')
    //   navigate('/enterprise/enterprise-admin/dashboard');
  };

  const fetchEmployeeUploadHistoryList = useCallback(async () => {
    refetch();

    //Animated Loader true
    dispatch(setLoaderTrue());
    try {
      const { data } = await client.query({
        query: GetUploadedHistoryByEnterpriseIdV2,
        variables: {
          input: {
            limit: 100,
            offset: 0,
            sort: "DESC"
          }
        },
      });

      setHistory(data?.getEmployeeUploadHistory?.uploadHistory);

      //Animated Loader false
      dispatch(setLoaderFalse());
    } catch (error) {
      if (error.networkError.statusCode) {
        const errorDetails = globalError(error.networkError.statusCode);
        toast.error(toastResponse('error', errorDetails.message));

        dispatch(isLogout());
        // navigate("/user/login");
        
        setTimeout(() => {
          window.location.href = '/user/login';
        }, 500);
      }
      //Animated Loader false
      dispatch(setLoaderFalse());

      console.error('Error in fetching enterprise list', error);
    }
  },[authReducer.enterpriseID, client, dispatch, refetch]);

  useEffect(() => {
    // Trigger refetch on component mount or when specific dependencies change
    refetch();
  }, [refetch]);

  useEffect(() => {
    // setHistory(data);
    fetchEmployeeUploadHistoryList();
  }, [fetchEmployeeUploadHistoryList]);


  return (
    <>
      <div className="row m-0 customTable border my-4">
        <div className="col-md-12">
          <div className="row customTable mainheader">
            <div className="col-md-8 ps-2 pt-1">
              <div className="customTable title">
                <label>Upload History</label>
              </div>
            </div>
            <div className="col-md-4">
              <div className="search-field position-relative">
                <div className="customTable static-search-mg">
                  <img
                    src={allImages.search}
                    className="img-fluid"
                    style={{ height: '1.2rem' }}
                    alt="search_icon"
                  />
                </div>
                <input
                  type="text"
                  placeholder="Search"
                  className="form-control customTable custom-input-field"
                  value={globalFilterValue}
                  onChange={(e) => {
                    setFilter((filters) => ({
                      ...filters,
                      global: {
                        ...filters['global'],
                        value: e?.target?.value.trim(),
                      },
                    }));
                    setGlobalFilterValue(e.target.value);
                  }}
                />
              </div>
            </div>
          </div>
        </div>
        <div className="col-md-12 p-0">
          <DataTable
            value={history}
            rowHover="true"
            removableSort
            className="customTable tableHeight"
            onRowClick={handleRowClick}
            globalFilterFields={[
              'fileId',
              'fileName',
              'uploadedOn',
              'totalEmp',
              'uploadStatus',
            ]}
            filters={filters}
            emptyMessage={
              (
                <h5 className="text-center h-100  pt-4 fw-bolder w-100">
                  There is no data to display at the moment.
                </h5>
              )
            }
            paginator
            rows={10}
            rowsPerPageOptions={[10, 20, 30, 40, 50]}
            scrollable
            scrollHeight="flex"
            resizableColumns="true"
          >
            <Column
              field="fileId"
              header="File ID"
              className="px-8"
              body={(rowData) => (rowData?.file?.id ?? 'dummy fileId')}
              sortable
            /> 
            <Column field="fileName" header="File Name" body={(rowData) => (rowData?.file?.fileName ?? 'Dummy filename')} sortable />
            <Column field="createdOn" header="Uploaded On" sortable />
            <Column field="totalEmp" header="Total Employees" body={(rowData) => (rowData?.uploadedEmployeeStats?.total ?? 0)} sortable />
            <Column
              field="status"
              header="Upload Status"
              sortable
              body={statusBody}
            />
          </DataTable>
        </div>
      </div>

      <RowDetailsOnHistoryPage
        show={showRowDetailsPopup}
        onHide={() => setShowRowDetailsPopup(false)}
        selectedRow = {selectedRow}
      />
    </>
  );
};

const RowDetailsOnHistoryPage = (props) => {
  console.log(props)

  const fnChangeDateFormat = (pDate) => {
    if (pDate) {
        let date = new Date(pDate);

        let day = String(date.getDate()).padStart(2, "0");
        var month = date.toLocaleString("default", { month: "short" });
        let year = date.getFullYear().toString().substring(2);
        // year= year.match(/\d{2}$/);
        var hrs = date.getHours();
        var mnts = date.getMinutes();
        var AMPM = hrs >= 12 ? "PM" : "AM";
        hrs = hrs % 12;
        hrs = hrs ? hrs : 12;
        mnts = mnts < 10 ? "0" + mnts : mnts;
        var time = hrs + ":" + mnts + " " + AMPM;
        // return <span className='ps-3'>  {month} {day}, {year}  {index === null ? "" : <br />} {time}  </span>;
        return (
          <span className="ps-0 ps-xxl-0">
            {" "}
            {month} {day}, '{year}, {time}{" "}
          </span>
        );
    } else {
      return <span>NA</span>;
    }
  }
  return (
    <>
      <Modal
      className="historyPagePopup"
        show={props.show}
        onHide={() => {
          props.onHide();
        }}
        size="md"
        aria-labelledby="contained-modal-title-vcenter"
        centered
      >
        <Modal.Header className="px-6 pt-6 pb-3 border-bottom-0" closeButton>
          <h3 className="fs-2">File History</h3>
        </Modal.Header>

        <Modal.Body className="px-8 py-0 pb-4 modal-body">
          <div className="analysisDetailsBlock">
            <div className="row">
              <div className="col-md-12">
                <h4 className="fs-3 mb-2">File Details</h4>
              </div>
            </div>
            <div className="row">
              <div className="col-md-3">
                <label>File ID</label>
              </div>
              <div className="col-md-9" style={{wordWrap:'break-word'}}>{props?.selectedRow?.data?.file?.id}</div>
            </div>
            <div className="row">
              <div className="col-md-3">
                <label>File Name</label>
              </div>
              <div className="col-md-9" style={{wordWrap:'break-word'}}>{props?.selectedRow?.data?.file?.fileName}</div>
            </div>
            <div className="row">
              <div className="col-md-3">
                <label>Status</label>
              </div>
              <div
                className="col-md-9 col-xxl-9"
                style={{
                  color:
                  props?.selectedRow?.data?.status === "DONE"
                      ? "#067647"
                      : "#D72C0D",
                }}
              >
                {props?.selectedRow?.data?.status}
              </div>
            </div>
            <div className="row">
              <div className="col-md-3 col-xxl-3 ">
                <label>Uploaded On</label>
              </div>
              <div className="col-md-9 col-xxl-9">
                {fnChangeDateFormat(props?.selectedRow?.data?.createdOn)}
              </div>
            </div>
            <div className="row">
              <div className="col-md-3">
                <label>Total Employees</label>
              </div>
              <div className="col-md-9">{props?.selectedRow?.data?.uploadedEmployeeStats.total}</div>
            </div>
            {/* <div
              className="row"
              style={{ display: props?.selectedRow?.data?.errorRecords === null ? "none" : "flex" }}
            >
              <div className="col-md-3">
                <label>Error Description</label>
              </div>
              <div
                className="col-md-9"
                style={{
                  color: "#D72C0D",
                  display: rowData?.errorMsg.length > 0 ? "block" : "none",
                }}
              >
                {rowData?.errorMsg.map((item) => {
                  item = rowData?.errorMsg.find(
                    (element) => element === "ERROR_SOME_TRAN_DATA_INVALID",
                  )
                    ? en.ERROR.CUSTOM.CODE[item]
                        ?.split("50%")
                        .join(rowData.garbagePercent) ?? item
                    : en.ERROR.CUSTOM.CODE[item] ?? item;
                  return <div>{item}</div>;
                })}
              </div>
              <div
                className="col-md-9"
                style={{
                  color: "#D72C0D",
                  display: rowData?.errorMsg.length === 0 ? "block" : "none",
                }}
              >
                NA
              </div>
            </div> */}
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
};
